import React from "react";
import Navbar from "../Navbar";
import Container from "react-bootstrap/Container";
import rideWithUs from "../../assets/newImg/Ride-with-us.jpg";
import rideWithUsAr from "../../assets/newImg/Ride-with-us-ar.jpg";
import partner_card_1 from "../../assets/partner_card_1.png";
import partner_card_2 from "../../assets/partner_card_2.png";
import partner_card_3 from "../../assets/partner_card_3.png";
import Accordion from "react-bootstrap/Accordion";
import Image from "react-bootstrap/Image";
import Footer from "./../footer/footer";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";

function RideWithUs() {
  const lng = cookies.get("i18next") || "en";

  const { t } = useTranslation();
  const imgsArray = [
    partner_card_1,
    partner_card_2,
    partner_card_3,
    partner_card_1,
    partner_card_2,
    partner_card_3,
  ];

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const onSubmit = (data) => console.log(data);

  const Card = () => {
    return (
      <>
        <div className="flex justify-center flex-wrap">
          {imgsArray.map((imageName) => {
            return (
              <div
                key={imageName}
                className="flex flex-col items-center m-3 w-[25rem] shadow-xl rounded-lg"
              >
                <Image className="w-[25rem] h-auto" src={imageName} />
                <div className="flex flex-col items-center my-3 p-3">
                  <p className="font-bold">Forem ipsum</p>
                  <p>
                    Morem ipsum dolor sit amet, consectetur adipiscing elit.
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </>
    );
  };

  // Function to open the link in a new tab
  const openGooglePlayLink = () => {
    window.open(
      "https://play.google.com/store/apps/details?id=com.extreme.find_help_delivery_app",
      "_blank"
    );
  };

  return (
    <Container fluid className="p-0">
      <Navbar />
      <Container fluid className="p-0 mb-5">
        <div className="w-full lg:h-[60vh] overflow-hidden flex justify-center">
          <Image
            className="w-[90%] h-full cursor-pointer object-fill shadow-lg"
            //h-fit shadow-lg h-[550px]
            src={lng === "en" ? rideWithUs : rideWithUsAr}
            alt="Ride with us cover"
            onClick={openGooglePlayLink} // Add onClick to open the link in a new tab
          />
        </div>
        <div className="flex flex-col justify-center items-center my-5">
          <p className="text-3xl font-bold">{t("WHY_PARTNER_HEADING")}</p>
          <p className="font-semibold">{t("WHY_PARTNER_CONTENT")}</p>
        </div>
        <div>{/* <Card /> */}</div>
        <div className="flex flex-col justify-center items-center my-5">
          <p className="text-4xl font-bold">{t("faq")}</p>
          <div className="w-2/3">
            <Accordion>
              {[
                "whats_find_help",
                "what_we_do",
                "why_use_find_help",
                "cost_of_using_find_help",
                "payment_options",
                "special_offers",
                "countdown_timer",
                "order_cancel_refund",
                "order_delivery_time",
                "cancel_order",
                "check_order_status",
                "reorder",
                "leave_comments",
                "multiple_orders",
                "use_discount_code",
              ].map((key, index) => (
                <Accordion.Item eventKey={index.toString()} key={key}>
                  <Accordion.Header>{t(key)}</Accordion.Header>
                  <Accordion.Body>{t(`${key}_desc`)}</Accordion.Body>
                </Accordion.Item>
              ))}
              <Accordion.Item eventKey="6">
                <Accordion.Header>{t("how_to_order")} </Accordion.Header>
                <Accordion.Body>
                  <ol>
                    <li>- {t("how_to_order_desc_one")}</li>
                    <li>- {t("how_to_order_desc_two")}</li>
                    <li>- {t("how_to_order_desc_three")}</li>
                    <li>- {t("how_to_order_desc_four")}</li>
                    <li>- {t("how_to_order_desc_five")}</li>
                    <li>- {t("how_to_order_desc_six")}</li>
                    <li>- {t("how_to_order_desc_seven")}</li>
                    <li>- {t("how_to_order_desc_eight")}</li>
                  </ol>
                </Accordion.Body>
              </Accordion.Item>
              <Accordion.Item eventKey="16">
                <Accordion.Header>
                  {t("discount_code_not_working")}
                </Accordion.Header>
                <Accordion.Body>
                  <ol>
                    <li>- {t("discount_code_not_working_desc_one")}</li>
                    <li>- {t("discount_code_not_working_desc_two")}</li>
                  </ol>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </div>
        </div>
      </Container>
      <Footer />
    </Container>
  );
}

export default RideWithUs;
